import { Trans, useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { PropTypes } from 'prop-types';

const ALLOWED_TOOLTIPS = ['standstill-early', 'standstill-after'];

const DrawTooltip = ({ tooltip, params, totalItems }) => {
  const { t } = useTranslation('OrderStop');

  const isAllowed = useMemo(
    () => ALLOWED_TOOLTIPS.includes(tooltip),
    [tooltip]
  );

  if (!isAllowed) {
    return null;
  }

  return (
    <div data-testid="draw-tooltip">
      <p>
        <b>{t('tooltips.standstill.title')}</b>
      </p>
      <p>
        <Trans
          t={t}
          i18nKey="tooltips.standstill.item_0"
          values={{
            text: t(
              `tooltips.standstill.item_0_fill${
                tooltip === 'standstill-early' ? '_early' : '_after'
              }`,
              { ...params }
            ),
          }}
          components={[<b>{{}}</b>]}
        />
      </p>
      <p>
        <Trans
          t={t}
          i18nKey="tooltips.standstill.item_1"
          values={{
            pallets: `${totalItems} ${t('loads:pallet', { totalItems })}`,
            text: t('tooltips.standstill.item_1_fill', { ...params }),
          }}
          components={[<b>{{}}</b>]}
        />
      </p>
      <p>
        <Trans
          t={t}
          i18nKey="tooltips.standstill.item_2"
          values={{
            text: t('tooltips.standstill.item_2_fill', { ...params }),
            ...params,
          }}
          components={[<b>{{}}</b>]}
        />
      </p>
    </div>
  );
};

DrawTooltip.propTypes = {
  tooltip: PropTypes.string,
  params: PropTypes.shape({
    item: PropTypes.string,
  }),
  totalItems: PropTypes.number.isRequired,
};

export default DrawTooltip;
